import React from 'react';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { ButtonLink } from '../components/ui/ButtonLink';
import { IMAGES } from '../data/images';
export function NotFound() {
  return <>
      <Seo title="Page not found" description="The page you were looking for could not be found." data-id="element-846" data-mp="104jsiw3lh9m9" />
      <PageHero title="Page not found" sub="That page moved or no longer exists. Let’s get you back on target." image={IMAGES.rangeWide} data-id="element-847" data-mp="1569021rlz55l">
        <ButtonLink to="/" size="lg" data-id="element-848" data-mp="1f2vjqn877q61">
          Back to Home
        </ButtonLink>
        <ButtonLink to="/courses" size="lg" variant="outline-light" data-id="element-849" data-mp="1jtu3xxwb58ek">
          Browse Courses
        </ButtonLink>
      </PageHero>
    </>;
}